module.exports = __webpack_public_path__ + "static/media/one_monkey_walk.951ec730.png";